module.exports = __webpack_public_path__ + "static/bany_vid-ca18f04a0623938bfeedac16d7e5120c.webp";